var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center py-5 my-4"},[_c('div',{staticClass:"col-12 col-sm-5"},[_c('b-card',[_c('forgot-password',{on:{"switch":_vm.switchUsecase}})],1)],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }